<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h1 class="title">Bed in twin</h1></app-cells>
      <div v-for="bed_table_item of bed_table" :key="bed_table_item.name" class="climbing-block">
        <app-cells v-if="bed_table_item.name">
          <h2 class="title">{{ bed_table_item.name }}</h2>
          <div v-if="bed_table_item.today" class="status-title" :style="{ 'backgroundColor': '#77b017' }">Today</div>
        </app-cells>
        <v-client-table
          :data="bed_table_item.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
          :class="{ 'table-default--loading': table_preloader }"
        >
          <template #h__name><div class="table-default__left">Name</div></template>
          <template #h__route.name><div class="table-default__left">Route</div></template>
          <template #h__before>Before<br>unallocated</template>
          <template #h__after>After<br>unallocated</template>
          <template #count="{ row, index }">{{ index }}</template>
          <template #name="{ row }">
            <div class="table-default__left">
              <router-link
                :to="{ name: 'reservation-bed-in-twin-detail', params: { id: row.id } }"
                class="table-default__link-border table-default__link-border--inline"
              >
                {{ row.name }}
              </router-link> ({{ row.pax }})
            </div>
          </template>
          <template #route.name="{ row }">
            <div class="table-default__left">{{ row.route.name }} {{ row.route.duration }}</div>
          </template>
          <template #allocated="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': !row.before_unallocated && !row.after_unallocated ? '#77b017' : '#e85c20' }"
          >
            {{ row.allocated }}
          </span>
          </template>
          <template #before="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': !row.before_unallocated ? '#77b017' : '#e85c20' }"
          >
            {{ row.before_unallocated }}
          </span>
          </template>
          <template #after="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': !row.after_unallocated ? '#77b017' : '#e85c20' }"
          >
            {{ row.after_unallocated }}
          </span>
          </template>
          <template #verified="{ row }">
          <span
            class="status-tag"
            :style="{ 'backgroundColor': row.allocated === row.verified ? '#77b017' : '#e85c20' }"
          >
            {{ row.verified }}
          </span>
          </template>
        </v-client-table>
      </div>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table_length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getClimbingGroupsBedInTwinByDates } from '@/http'

export default {
  name: 'ReservationsBedInTwinList',
  data() {
    return {
      page_loaded: false,
      bed_table: [],
      table_length: 0,
      table: {
        items: [],
        columns: ['count', 'name', 'route.name', 'allocated', 'before', 'after', 'verified'],
        options: {
          headings: {
            'count': '#',
            'name': 'Name',
            'route.name': 'Route',
            'allocated': 'Allocated',
            'before': 'Before unallocated',
            'after': 'After unallocated',
            'verified': 'Verified ',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader: false,
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      const params = {
        page: this.pagination.page,
        page_size: 20,
        group_by: 'tour_start',
        range_type: 'day',
      }
      this.table_preloader = true
      getClimbingGroupsBedInTwinByDates(params)
        .then(res => {
          this.bed_table = res.data.results.length ? res.data.results : [{name: '', items: []}]
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.table_length = 0
          res.data.results.forEach(item => {
            this.table_length += item.items.length
          })
          this.page_loaded = true
          this.table_preloader = false
        })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
  }
}
</script>

<style lang="sass" scoped>
.climbing-block
  margin-bottom: 30px
</style>
